import React, { useRef } from 'react';
import AfCharts from '../../components/af-charts';
import PersonalInfoBox from '../../components/personal-info-box';
import ReportHeader from '../../components/report-header';
import '../../css/reports.css';
function AfReportComponent({ data, isPdf = false }) {
    console.log('ALL AF DATA', data);
    const refToPrint = useRef(null);
    const { patientProfile: patient, patientQuestions, questionsScore, reportDates, appConfiguration, af_data, af_detection_summary_data, histogram_data, medications } = data;
    const afChartsData = {
        af_data,
        af_detection_summary_data,
        histogram_data,
    };
    return (React.createElement("div", { ref: refToPrint, className: `wrap-af-report wrap-monthly-report wrap-report ${isPdf ? 'is-pdf' : 'is-not-pdf'}` },
        React.createElement(ReportHeader, { refToPrint: refToPrint, title: 'AF Report', user: patient, isPdf: isPdf, startDate: reportDates === null || reportDates === void 0 ? void 0 : reportDates.start, endDate: reportDates === null || reportDates === void 0 ? void 0 : reportDates.end }),
        React.createElement(PersonalInfoBox, { user: patient, patientQuestions: patientQuestions, questionsScore: questionsScore, medications: medications }),
        React.createElement(AfCharts, { afChartsData: afChartsData, isPdf: isPdf })));
}
export default AfReportComponent;
